(function () {
  if (window.cardSwatchHoverBound) return;
  window.cardSwatchHoverBound = true;

  const normalize = (value) => (value || '').trim().toLowerCase();

  const getSwatchLabel = (swatch) =>
    swatch.getAttribute('data-color-name') || swatch.getAttribute('aria-label') || '';

  const getCard = (element) => element.closest('.product-card-wrapper');

  const imageMatchesSwatch = (image, swatch) => {
    const swatchHandle = normalize(swatch.getAttribute('data-color') || '');
    const imageAlt = normalize(image.getAttribute('alt'));

    if (swatchHandle && imageAlt && imageAlt === swatchHandle) {
      return true;
    }

    const variantId = swatch.getAttribute('data-variant-id');
    if (variantId && image.getAttribute('data-variant-id') === variantId) {
      return true;
    }

    const swatchLabel = normalize(getSwatchLabel(swatch));
    if (swatchLabel && imageAlt && (imageAlt === swatchLabel || imageAlt.includes(swatchLabel))) {
      return true;
    }

    return Boolean(swatchHandle && image.getAttribute('data-color') === swatchHandle);
  };

  const showColor = (card, swatch, persist) => {
    const isPreview = card.classList.contains('is-swatch-preview');

    card.querySelectorAll('.card-color-image').forEach((image) => {
      const matches = imageMatchesSwatch(image, swatch);
      const shouldActivate = matches && !(isPreview && image.classList.contains('is-hover'));
      image.classList.toggle('is-active', shouldActivate);
    });

    card.querySelectorAll('.card-swatch').forEach((item) => {
      item.classList.toggle('is-selected', item === swatch);
    });

    if (persist) {
      card.dataset.swatchLocked = 'true';
      card.dataset.lockedColor = swatch.getAttribute('data-color') || '';
      card.dataset.lockedVariant = swatch.getAttribute('data-variant-id') || '';
      card.dataset.lockedColorName = getSwatchLabel(swatch);
    }
  };

  const findSwatch = (card, color, variantId, colorName) => {
    if (colorName) {
      const normalizedName = normalize(colorName);
      const byName = Array.from(card.querySelectorAll('.card-swatch')).find(
        (swatch) => normalize(getSwatchLabel(swatch)) === normalizedName
      );
      if (byName) return byName;
    }

    if (variantId) {
      const byVariant = card.querySelector('.card-swatch[data-variant-id="' + variantId + '"]');
      if (byVariant) return byVariant;
    }

    if (color) {
      const byColor = card.querySelector('.card-swatch[data-color="' + color + '"]');
      if (byColor) return byColor;
    }

    return null;
  };

  const restoreColor = (card) => {
    const lockedVariant = card.dataset.swatchLocked === 'true' ? card.dataset.lockedVariant : '';
    const lockedColor = card.dataset.swatchLocked === 'true' ? card.dataset.lockedColor : '';
    const lockedColorName = card.dataset.swatchLocked === 'true' ? card.dataset.lockedColorName : '';
    const fallback =
      card.querySelector('.card-swatch[data-default-selected="true"]') ||
      card.querySelector('.card-swatch.is-selected') ||
      card.querySelector('.card-swatch');
    const swatch = findSwatch(card, lockedColor, lockedVariant, lockedColorName) || fallback;

    if (swatch) showColor(card, swatch, card.dataset.swatchLocked === 'true');
  };

  const initCard = (card) => {
    const defaultSwatch =
      card.querySelector('.card-swatch[data-default-selected="true"]') ||
      card.querySelector('.card-swatch.is-selected');

    if (defaultSwatch) {
      showColor(card, defaultSwatch, false);
      return;
    }

    const activeMainImage = card.querySelector('.card-color-image.is-main.is-active');
    if (activeMainImage) {
      const activeAlt = normalize(activeMainImage.getAttribute('alt'));
      const swatchByAlt = Array.from(card.querySelectorAll('.card-swatch')).find((swatch) => {
        const swatchHandle = normalize(swatch.getAttribute('data-color') || '');
        return swatchHandle === activeAlt || normalize(getSwatchLabel(swatch)) === activeAlt;
      });
      if (swatchByAlt) showColor(card, swatchByAlt, false);
      return;
    }

    const firstSwatch = card.querySelector('.card-swatch');
    if (firstSwatch) {
      showColor(card, firstSwatch, false);
      return;
    }

    const firstImage = card.querySelector('.card-color-image.is-main');
    if (firstImage) firstImage.classList.add('is-active');
  };

  const initCardSwatches = (root = document) => {
    root.querySelectorAll('.product-card-wrapper').forEach((card) => {
      if (card.dataset.swatchInit === 'true') return;
      card.dataset.swatchInit = 'true';
      initCard(card);
    });
  };

  const observeProductGrid = () => {
    const grid = document.getElementById('product-grid');
    if (!grid || grid.dataset.swatchObserverBound === 'true') return;

    grid.dataset.swatchObserverBound = 'true';
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches?.('.product-card-wrapper')) initCard(node);
          node.querySelectorAll?.('.product-card-wrapper').forEach(initCard);
        });
      });
    }).observe(grid, { childList: true });
  };

  document.addEventListener(
    'pointerover',
    (event) => {
      const swatch = event.target.closest('.card-swatch');
      if (!swatch) return;
      const card = getCard(swatch);
      if (!card) return;
      card.classList.add('is-swatch-preview');
      showColor(card, swatch, false);
    },
    true
  );

  document.addEventListener(
    'pointerout',
    (event) => {
      const swatches = event.target.closest('.card-swatches');
      if (!swatches) return;
      if (event.relatedTarget && swatches.contains(event.relatedTarget)) return;
      const card = getCard(swatches);
      if (!card) return;
      card.classList.remove('is-swatch-preview');
      restoreColor(card);
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const swatch = event.target.closest('.card-swatch');
      if (!swatch) return;
      const card = getCard(swatch);
      if (!card) return;

      event.preventDefault();
      event.stopPropagation();
      card.classList.remove('is-swatch-preview');
      showColor(card, swatch, true);

      const productLink = card.querySelector('.card-media-link, .card__heading a');
      const url = swatch.getAttribute('data-product-url');
      if (productLink && url) productLink.setAttribute('href', url);
    },
    true
  );

  const boot = () => {
    initCardSwatches();
    observeProductGrid();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('product-grid:updated', () => {
    initCardSwatches();
  });
})();
